import localStorageUtil from '../localStorageUtil';
import { storageConstants } from '../constants/storageConstants';

export const updateLocalStorage = (json: any) => {
  const storedApiHost = localStorageUtil.getApiURl();

  if (storedApiHost !== json.VUE_APP_API_HOST) {
    localStorageUtil.removeBrandCode();
  }

  const configItems = {
    [storageConstants.vueAppApiHost]: json[storageConstants.vueAppApiHost],
    [storageConstants.vueAppPaymentHost]: json[storageConstants.vueAppPaymentHost],
    [storageConstants.naverKey]: json[storageConstants.naverKey],
    [storageConstants.telegramBot]: json[storageConstants.telegramBot],
    [storageConstants.telegramUrl]: json[storageConstants.telegramUrl],
    [storageConstants.skillPathAuth]: json[storageConstants.skillPathAuth],
  };

  Object.entries(configItems).forEach(([key, value]) => {
    if (value) {
      if (Array.isArray(value)) {
        localStorage.setItem(key, JSON.stringify(value)); // 배열을 JSON 문자열로 변환하여 저장
      } else {
        localStorage.setItem(key, value); // string 타입은 그대로 저장
      }
    }
  });

  Object.entries(configItems).forEach(([key, value]) => {
    if (value) {
      const stringValue = Array.isArray(value) ? value.join(',') : value;
      localStorage.setItem(key, stringValue);
    }
  });
};

export const updateBrowserTitle = () => {
  const browserTitle = localStorage.getItem(storageConstants.browserTitle);
  if (browserTitle) {
    document.title = browserTitle;
  }
};
